import type { MisconceptionDefinition } from '../types'

export const STU_DIAGRAMMEN_MISCONCEPTIONS: MisconceptionDefinition[] = [
  // ───────────────────────────────────────────────────────────
  // STU-DIAGRAM — diagram-keuze en -lezen
  // ───────────────────────────────────────────────────────────
  {
    id: 'stu.diagram-kwart-derde-verward',
    label: '¼ en ⅓ verward',
    module: 'Studievaardig',
    description:
      'Leerling herkent het verschil tussen een kwart-segment en een derde-segment in een cirkeldiagram niet visueel.',
    typicalFamilies: ['STU-DIAGRAM', 'STU-CIRKEL'],
  },
  {
    id: 'stu.diagram-percentage-als-aantal',
    label: 'Percentage als aantal gelezen',
    module: 'Studievaardig',
    description:
      'Leerling leest een percentage in het diagram als absoluut aantal i.p.v. relatief deel.',
    typicalFamilies: ['STU-DIAGRAM', 'STU-CIRKEL'],
  },
  {
    id: 'stu.diagram-kwart-half-verward',
    label: '¼ en ½ verward',
    module: 'Studievaardig',
    description: 'Leerling verwart een kwart met een half in cirkeldiagrammen.',
    typicalFamilies: ['STU-DIAGRAM', 'STU-CIRKEL'],
  },
  {
    id: 'stu.diagram-cirkel-voor-tijdverloop',
    label: 'Cirkeldiagram voor tijdverloop',
    module: 'Studievaardig',
    description:
      'Leerling kiest een cirkeldiagram (deel-van-geheel) waar een lijndiagram (verloop) passender is.',
    typicalFamilies: ['STU-DIAGRAM'],
  },
  {
    id: 'stu.diagram-staaf-voor-trend',
    label: 'Staafdiagram voor trend',
    module: 'Studievaardig',
    description:
      'Leerling kiest een staafdiagram (categorisch) waar een lijndiagram (trend) passender is.',
    typicalFamilies: ['STU-DIAGRAM'],
  },
  {
    id: 'stu.diagram-pictogram-voor-continu',
    label: 'Pictogram voor continue data',
    module: 'Studievaardig',
    description:
      'Leerling kiest een pictogram (discrete categorieën) voor continue meetgegevens.',
    typicalFamilies: ['STU-DIAGRAM'],
  },

  // ───────────────────────────────────────────────────────────
  // STU-CIRKEL — cirkeldiagram-specifiek
  // ───────────────────────────────────────────────────────────
  {
    id: 'stu.cirkel-som-niet-100',
    label: 'Som is niet 100%',
    module: 'Studievaardig',
    description:
      'Leerling herkent niet dat een cirkeldiagram altijd optelt tot 100%.',
    typicalFamilies: ['STU-CIRKEL'],
  },
  {
    id: 'stu.cirkel-percentage-breuk-koppeling',
    label: 'Percentage en breuk verkeerd gekoppeld',
    module: 'Studievaardig',
    description:
      'Leerling koppelt een percentage aan de verkeerde breuk (bijv. 25% aan 1/2).',
    typicalFamilies: ['STU-CIRKEL'],
  },

  // ───────────────────────────────────────────────────────────
  // STU-LIJN — lijndiagrammen (basis, trend & verschil)
  // ───────────────────────────────────────────────────────────
  {
    id: 'stu.lijn-steilheid-genegeerd',
    label: 'Steilheid genegeerd',
    module: 'Studievaardig',
    description:
      'Leerling negeert de steilheid van de lijn bij het bepalen van de snelste stijging/daling.',
    typicalFamilies: ['STU-LIJN'],
  },
  {
    id: 'stu.lijn-eindwaarde-zonder-verandering',
    label: 'Eindwaarde zonder verandering',
    module: 'Studievaardig',
    description:
      'Leerling kijkt alleen naar de eindwaarde in plaats van naar de verandering.',
    typicalFamilies: ['STU-LIJN'],
  },
  {
    id: 'stu.lijn-trend-zonder-aflezen',
    label: 'Trend zonder aflezen',
    module: 'Studievaardig',
    description:
      'Leerling trekt een conclusie over de trend zonder de waarden goed af te lezen.',
    typicalFamilies: ['STU-LIJN'],
  },
  {
    id: 'stu.lijn-trend-alleen-stijgend',
    label: 'Trend als alleen-stijgend gelezen',
    module: 'Studievaardig',
    description:
      'Leerling beoordeelt een wisselende trend als stijgend zonder de dalingen in de lijn mee te wegen.',
    typicalFamilies: ['STU-LIJN'],
  },
  {
    id: 'stu.lijn-trend-alleen-dalend',
    label: 'Trend als alleen-dalend gelezen',
    module: 'Studievaardig',
    description:
      'Leerling beoordeelt een wisselende trend als dalend zonder de stijgingen in de lijn mee te wegen.',
    typicalFamilies: ['STU-LIJN'],
  },
  {
    id: 'stu.lijn-trend-gelijk-verondersteld',
    label: 'Trend als gelijk verondersteld',
    module: 'Studievaardig',
    description:
      'Leerling denkt dat de waarden gelijk blijven terwijl ze duidelijk verschillen.',
    typicalFamilies: ['STU-LIJN'],
  },
  {
    id: 'stu.lijn-verschil-beginwaarde-als-groei',
    label: 'Beginwaarde gekozen i.p.v. verschil',
    module: 'Studievaardig',
    description:
      'Leerling geeft de beginwaarde als antwoord op een verschil-/groeivraag in plaats van eindwaarde − beginwaarde.',
    typicalFamilies: ['STU-LIJN'],
  },
  {
    id: 'stu.lijn-verschil-eindwaarde-als-groei',
    label: 'Eindwaarde gekozen i.p.v. verschil',
    module: 'Studievaardig',
    description:
      'Leerling geeft de eindwaarde als antwoord op een verschil-/groeivraag in plaats van eindwaarde − beginwaarde.',
    typicalFamilies: ['STU-LIJN'],
  },
  {
    id: 'stu.lijn-verschil-verkeerde-range',
    label: 'Verschil over verkeerde periode berekend',
    module: 'Studievaardig',
    description:
      'Leerling berekent het verschil over een andere periode dan in de vraag genoemd (bv. vanaf week 1 i.p.v. week 2).',
    typicalFamilies: ['STU-LIJN'],
  },

  // ───────────────────────────────────────────────────────────
  // STU-STAAF — staafdiagram lezen
  // ───────────────────────────────────────────────────────────
  {
    id: 'stu.staaf-vergeet-laatste-staaf',
    label: 'Vergeet laatste staaf',
    module: 'Studievaardig',
    description:
      'Leerling vergeet de laatste staaf mee te nemen in de berekening.',
    typicalFamilies: ['STU-STAAF'],
  },
  {
    id: 'stu.staaf-rekenfout-optellen',
    label: 'Rekenfout bij optellen staven',
    module: 'Studievaardig',
    description:
      'Leerling maakt een rekenfout bij het optellen van de waarden van meerdere staven.',
    typicalFamilies: ['STU-STAAF'],
  },
  {
    id: 'stu.staaf-verwachting-boven-data',
    label: 'Verwachting boven data',
    module: 'Studievaardig',
    description:
      'Leerling baseert verwachting op eigen aannames in plaats van op de data in het diagram.',
    typicalFamilies: ['STU-STAAF'],
  },
  {
    id: 'stu.staaf-hoogste-laagste-omgedraaid',
    label: 'Hoogste en laagste omgedraaid',
    module: 'Studievaardig',
    description: 'Leerling verwart de hoogste staaf met de laagste.',
    typicalFamilies: ['STU-STAAF'],
  },
  {
    id: 'stu.staaf-conclusie-zonder-aflezen',
    label: 'Conclusie zonder aflezen',
    module: 'Studievaardig',
    description:
      'Leerling trekt een conclusie zonder de exacte waarden van de staven af te lezen.',
    typicalFamilies: ['STU-STAAF'],
  },

  // ── Nieuwe entries (seeds-driven gap closure, juni 2026) ──────────────────
  // ── STU-STAAF — staafdiagram aflezen & vergelijken ───────────────────────
  {
    id: 'stu.staaf-vergeet-laatste-staaf',
    label: 'Laatste staaf vergeten bij optellen',
    module: 'Studievaardigheden',
    description:
      'Leerling stopt te vroeg met optellen en vergeet de laatste staaf mee te tellen — typisch een werkgeheugen/leesvolgorde-fout bij staafdiagrammen met 4+ categorieën.',
    typicalFamilies: ['STU-STAAF'],
  },
  {
    id: 'stu.staaf-rekenfout-optellen',
    label: 'Rekenfout bij optellen van staafwaarden',
    module: 'Studievaardigheden',
    description:
      'Leerling leest de staven correct af maar maakt een rekenfout in het optellen (bijv. cijfer-fout, vergeten over te dragen).',
    typicalFamilies: ['STU-STAAF'],
  },
  {
    id: 'stu.staaf-totaal-fout-getal',
    label: 'Totaal gegeven dat niet past',
    module: 'Studievaardigheden',
    description:
      'Leerling geeft een totaal dat duidelijk niet bij de zichtbare staafhoogtes past — gecombineerde aflees- en rekenfout zonder check.',
    typicalFamilies: ['STU-STAAF'],
  },
  {
    id: 'stu.staaf-verwacht-boven-data',
    label: 'Verwachting overstemt data',
    module: 'Studievaardigheden',
    description:
      'Leerling antwoordt op basis van een vooroordeel of verwachting in plaats van te kijken wat de staven feitelijk tonen — confirmation bias op grafiekdata.',
    typicalFamilies: ['STU-STAAF'],
  },
  {
    id: 'stu.staaf-hoogste-laagste-omdraaien',
    label: 'Hoogste en laagste staaf omgedraaid',
    module: 'Studievaardigheden',
    description:
      'Leerling wisselt "hoogste" en "laagste" om bij een vraag over uitersten — taal- of richting-fout (min/max-verwisseling).',
    typicalFamilies: ['STU-STAAF'],
  },
  {
    id: 'stu.staaf-conclusie-zonder-aflezen',
    label: 'Conclusie zonder af te lezen',
    module: 'Studievaardigheden',
    description:
      'Leerling trekt een conclusie over een staafdiagram zonder de waarden daadwerkelijk af te lezen — typisch bij vragen waar de y-as is verborgen.',
    typicalFamilies: ['STU-STAAF'],
  },
  // ── STU-CIRKEL — cirkeldiagram interpreteren ─────────────────────────────
  {
    id: 'stu.cirkel-som-niet-100',
    label: 'Cirkelpercentages tellen niet op tot 100',
    module: 'Studievaardigheden',
    description:
      'Leerling herkent niet dat de percentages in een cirkeldiagram per definitie optellen tot 100% — gebruikt deze regel niet als checksum bij een ontbrekend segment.',
    typicalFamilies: ['STU-CIRKEL'],
  },
  {
    id: 'stu.cirkel-kleinste-grootste-omdraaien',
    label: 'Kleinste en grootste segment omgedraaid',
    module: 'Studievaardigheden',
    description:
      'Leerling wisselt het kleinste en grootste cirkelsegment om — min/max-verwisseling in cirkel-context, parallel aan stu.staaf-hoogste-laagste-omdraaien.',
    typicalFamilies: ['STU-CIRKEL'],
  },
  {
    id: 'stu.cirkel-percentage-breuk-koppeling',
    label: 'Percentage ↔ breuk koppeling fout',
    module: 'Studievaardigheden',
    description:
      'Leerling koppelt percentages en gangbare breuken in een cirkeldiagram verkeerd (bijv. 25% ≠ ¼, 50% ≠ ½). Cross-module link met get.proc-* familie.',
    typicalFamilies: ['STU-CIRKEL'],
  },
]
